export default __webpack_public_path__ + "static/media/clock.623246e1.svg";